import { addListingToCart, fetchCartInfo, removeListingFromCart } from '../util/api';
import { storableError } from '../util/errors';

// ================ Action types ================ //

export const FETCH_CART_DATA_REQUEST = 'app/cart/FETCH_CART_DATA_REQUEST';
export const FETCH_CART_DATA_SUCCESS = 'app/cart/FETCH_CART_DATA_SUCCESS';
export const FETCH_CART_DATA_ERROR = 'app/cart/FETCH_CART_DATA_ERROR';

export const ADD_TO_CART_REQUEST = 'app/cart/ADD_TO_CART_REQUEST';
export const ADD_TO_CART_SUCCESS = 'app/cart/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'app/cart/ADD_TO_CART_ERROR';

export const REMOVE_FROM_CART_REQUEST = 'app/cart/REMOVE_FROM_CART_REQUEST';
export const REMOVE_FROM_CART_SUCCESS = 'app/cart/REMOVE_FROM_CART_SUCCESS';
export const REMOVE_FROM_CART_ERROR = 'app/cart/REMOVE_FROM_CART_ERROR';

// ================ Reducer ================ //

const initialState = {
    cartItems: [],
    totalPrice: null,
    discount: null,
    originalPrice: null,

    fetchCartDataInProgress: false,
    fetchCartDataError: null,

    addToCartInProgress: false,
    addToCartError: null,

    removeFromCartInProgress: false,
    removeFromCartError: null,
};

export default function reducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        case FETCH_CART_DATA_REQUEST:
            return {
                ...state,
                fetchCartDataInProgress: payload,
                fetchCartDataError: null,
            };
        case FETCH_CART_DATA_SUCCESS:
            return {
                ...state,
                cartItems: payload.cartItems,
                totalPrice: payload.totalPrice,
                discount: payload.discount,
                originalPrice: payload.originalPrice,
                fetchCartDataInProgress: false,
            };
        case FETCH_CART_DATA_ERROR:
            return {
                ...state,
                fetchCartDataInProgress: false,
                fetchCartDataError: payload,
            };

        case ADD_TO_CART_REQUEST:
            return {
                ...state,
                addToCartInProgress: true,
                addToCartError: null,
            };
        case ADD_TO_CART_SUCCESS:
            return {
                ...state,
                addToCartInProgress: false,
            };
        case ADD_TO_CART_ERROR:
            return {
                ...state,
                addToCartInProgress: false,
                addToCartError: payload,
            };

        case REMOVE_FROM_CART_REQUEST:
            return {
                ...state,
                removeFromCartInProgress: true,
                removeFromCartError: null,
            };
        case REMOVE_FROM_CART_SUCCESS:
            return {
                ...state,
                removeFromCartInProgress: false,
            };
        case REMOVE_FROM_CART_ERROR:
            return {
                ...state,
                removeFromCartInProgress: false,
                removeFromCartError: payload,
            };

        default:
            return state;
    }
}

// ================ Action creators ================ //

export const fetchCartDataRequest = isInProgress => ({
    type: FETCH_CART_DATA_REQUEST,
    payload: isInProgress,
});

export const fetchCartDataSuccess = cartData => ({
    type: FETCH_CART_DATA_SUCCESS,
    payload: cartData,
});

export const fetchCartDataError = e => ({
    type: FETCH_CART_DATA_ERROR,
    error: true,
    payload: e,
});

export const addToCartRequest = () => ({
    type: ADD_TO_CART_REQUEST,
});

export const addToCartSuccess = () => ({
    type: ADD_TO_CART_SUCCESS,
});

export const addToCartError = e => ({
    type: ADD_TO_CART_ERROR,
    error: true,
    payload: e,
});

export const removeFromCartRequest = () => ({
    type: REMOVE_FROM_CART_REQUEST,
});

export const removeFromCartSuccess = () => ({
    type: REMOVE_FROM_CART_SUCCESS,
});

export const removeFromCartError = e => ({
    type: REMOVE_FROM_CART_ERROR,
    error: true,
    payload: e,
});

// ================ Thunks ================ //

export const fetchCartData = (isInProgress = false) => (dispatch, getState, sdk) => {
    dispatch(fetchCartDataRequest(isInProgress));
    return fetchCartInfo()
        .then(response => {
            const data = response.data;
            dispatch(fetchCartDataSuccess(data));
            return data;
        })
        .catch(e => {
            dispatch(fetchCartDataError(storableError(e)));
        });
};

export const addToCart = listingId => async (dispatch, getState, sdk) => {
    dispatch(addToCartRequest());
    return addListingToCart({ listingId })
        .then(async () => {
            await dispatch(fetchCartData());
            dispatch(addToCartSuccess());
        })
        .catch(e => {
            dispatch(addToCartError(storableError(e)));
        });
};

export const removeFromCart = listingId => async (dispatch, getState, sdk) => {
    dispatch(removeFromCartRequest());
    return removeListingFromCart(listingId)
        .then(async () => {
            await dispatch(fetchCartData());
            dispatch(removeFromCartSuccess());
        })
        .catch(e => {
            dispatch(removeFromCartError(storableError(e)));
        });
};
